<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 pb-5">
                <!-- Header -->
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col">
                                <h6 class="header-pretitle">{{ $t('People') }}</h6>
                                <h1 class="header-title">{{ $t('Labs') }}</h1>
                            </div>
                            <div class="col-auto">
                                <button
                                    @click="openModal({id:'LabModal'})"
                                    class="btn btn-primary"
                                >{{ $t('New work') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" data-toggle="lists">
                    <div class="card-header">
                        <div class="row align-items-center">
                            <div class="col"></div>

                            <!--date filter-->
                            <div class="d-none d-xl-block col-auto">
                                <date-filter
                                    v-model="dates"
                                    :initial="'this_week'"
                                    :label="$t('filters.by-completion-date')"
                                ></date-filter>
                            </div>

                            <!--team filter-->
                            <div class="d-none d-xl-block col-auto" v-if="$hasPermission('labs', ['seeAll'])">
                                <team-filter v-model="user"></team-filter>
                            </div>

                            <!--status filter-->
                            <div class="d-none d-xl-block col-auto">
                                <div class="dropdown">
                                    <b-button-group>
                                        <button
                                            class="btn btn-white"
                                            @click="statusQuery=[]"
                                            v-if="statusQuery.length>0"
                                        >
                                            <span class="fe fe-x"></span>
                                        </button>
                                        <b-dropdown variant="white" right :text="$t('Status')">
                                            <div
                                                v-for="(status, index ) in statusList"
                                                :key="index"
                                                class="dropdown-item pl-3"
                                            >
                                                <b-form-checkbox v-model="statusQuery" :value="index">
                                                    <b-badge pill :variant="status.variant">
                                                        <i class="fe" :class="status.icon"></i>
                                                    </b-badge>
                                                    {{ $t(status.label) }}
                                                </b-form-checkbox>
                                            </div>
                                        </b-dropdown>
                                    </b-button-group>
                                </div>
                            </div>

                            <!-- filter button -->
                            <div class="col-auto d-xl-none">
                                <b-button @click="openModal({id:'labsFilterModal'})" variant="white" size="md">
                                    <i class="fe fe-filter"></i>
                                </b-button>
                            </div>
                        </div>
                        <!-- / .row -->
                    </div>
                </div>

                <div class="card card-inactive" v-if="!labs.length && !areLabsLoading">
                    <div class="card-body text-center text-muted small">
                        <div class="row justify-content-center">
                            <div class="col-12 mt-5">
                                <div class="d-flex justify-content-center">
                                    <img
                                        src="@/assets/img/illustrations/32desk/lab.svg"
                                        class="img-fluid mt-n5 mb-5"
                                        style="max-height: 400px;"
                                    />
                                </div>
                                <p class="text-muted mb-4">{{ $t('Nothing yet') }}</p>
                            </div>
                            <div class="col-12">
                                <button
                                    @click="openModal({id:'LabModal'})"
                                    class="btn btn-primary"
                                >{{ $t('New work') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <labs-list :labs="labs" :loading="areLabsLoading"></labs-list>
            </div>
        </div>
        <lab-modal id="LabModal"></lab-modal>
        <print-lab-modal id="PrintLabModal"></print-lab-modal>
        <remove-modal id="LabRemoveModal"></remove-modal>

        <mobile-filters-modal id="labsFilterModal">

            <!--date filter-->
            <div class="col-12 mb-3">
                <date-filter v-model="dates" :initial="'this_week'"></date-filter>
            </div>

            <!--team filter-->
            <div class="col-12 mb-3" v-if="$hasPermission('labs', ['seeAll'])">
                <team-filter v-model="user"></team-filter>
            </div>

            <!--status filter-->
            <div class="col-12 mb-3">
                <div class="dropdown">
                    <b-button-group>
                        <button
                            class="btn btn-white"
                            @click="statusQuery=[]"
                            v-if="statusQuery.length>0"
                        >
                            <span class="fe fe-x"></span>
                        </button>
                        <b-dropdown variant="white" right :text="$t('Status')">
                            <div
                                v-for="(status, index ) in statusList"
                                :key="index"
                                class="dropdown-item pl-3"
                            >
                                <b-form-checkbox v-model="statusQuery" :value="index">
                                    <b-badge pill :variant="status.variant">
                                        <i class="fe" :class="status.icon"></i>
                                    </b-badge>
                                    {{ $t(status.label) }}
                                </b-form-checkbox>
                            </div>
                        </b-dropdown>
                    </b-button-group>
                </div>
            </div>
        </mobile-filters-modal>

    </div>
</template>

<script>
import {modalMixins} from '@/mixins/modal.js';
import TeamFilter from "@/components/TeamFilter";
import DateFilter from "@/components/DateFilter";
import debounce from 'lodash/debounce';
import User from "@/components/User";
import LabModal from "./LabModal";
import {statusList} from '@/filters/lab-status.js';
import {mapActions, mapGetters, mapState} from 'vuex';
import CustomerCard from "@/components/CustomerCard";
import LabsList from "@/components/Lab/LabsList.vue"
import StatusBadge from './StatusBadge'
import PrintLabModal from "./PrintLabModal";
import RemoveModal from "./RemoveModal";
import ConfirmableButton from "@/components/ConfirmableButton";
import mobileFiltersModal from "@/components/mobileFiltersModal";

export default {
    name: "Labs",
    components: {
        ConfirmableButton,
        RemoveModal,
        PrintLabModal,
        User,
        LabModal,
        TeamFilter,
        LabsList,
        DateFilter,
        StatusBadge,
        CustomerCard,
        mobileFiltersModal,
    },
    mixins: [modalMixins],
    data() {
        return {
            hideForm: false,
            currentLab: 0,
            dates: {},
            user: [],
            statusQuery: []
        }
    },
    watch: {
        params: debounce(function() {
            this.fetchLabs();
        }, 400),
    },
    computed: {
        ...mapGetters('labs', {findLabsInStore: 'find'}),
        ...mapState('labs', {areLabsLoading: 'isFindPending'}),

        labs() {
            const query = this.params.query
            return this.findLabsInStore({
                query: {
                    ...query,
                    _id: {$ne: 'temp'},
                    $sort: {status: -1, createdAt: -1}
                }
            }).data
        },

        params() {
            let query = {
                $sort: {createdAt: -1}
            };

            if (this.user.length)
                query.userId = {$in: this.user};

            if (this.dates.start)
                query.dueDate = {$lte: this.dates.end, $gte: this.dates.start};

            if (this.statusQuery.length)
                query.status = {$in: this.statusQuery};

            return {query};
        },

        statusList() {
            return statusList;
        }
    },
    mounted() {
    },
    methods: {
        ...mapActions('labs', ['find', 'patch']),


        setCurrent(index) {
            this.currentLab = index
        },

        setStatus(lab, status) {
            this.patch([lab._id, {status: status}]);
            this.currentLab = 0;
        },

        fetchLabs() {
            this.find(this.params);
        },

        isDueDate(dueDate) {
            return this.$moment(dueDate) <= this.$moment()
        },

        openRemoveModal(lab) {
            this.openModal({id: 'LabRemoveModal'});
            const {Lab} = this.$FeathersVuex;
            new Lab({
                model: lab,
                _id: 'temp'
            });
        },

        openPrintModal(lab) {
            this.openModal({id: 'PrintLabModal'});
            const {Lab} = this.$FeathersVuex;
            new Lab({
                model: lab,
                _id: 'temp'
            });
        },

        openLabModal(lab) {
            this.openModal({id: 'LabModal'});
            const {Lab} = this.$FeathersVuex;
            new Lab({
                model: lab,
                _id: 'temp'
            });
        },

        openAppointmentModal(lab) {
            let data = {};
            if (lab.customerId)
                data.customerId = lab.customerId;
            data.startAt = (lab.fittings && lab.fittings.length ? lab.fittings[0].date : null) || lab.dueDate;
            data.services = [{}];
            this.openModal({id: 'AppointmentFastModal'});
            const {Appointment} = this.$FeathersVuex;

            new Appointment({
                model: data,
                _id: 'temp'
            });
        }
    }
}
</script>

<style scoped>

</style>
